/**
 * Created by Pankaj singh on 2019-10-11.
 */
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {BitmapWinCountUp} from "@nolimitcity/slot-game/bin/game/winpresentation/countup/BitmapWinCountUp";
import {Elastic, Power3, Timeline, TimelineLite, TweenLite} from "gsap";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {RomanEmpireEvents} from "../../events/RomanEmpireEvents";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {SoundManager} from "../../resource/sound/SoundManager";
import {RomanEmpireSoundConfig} from "../../RomanEmpireSoundConfig";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {RomanEmpireGameConfig} from "../../RomanEmpireGameConfig";

export class RomanEmpireInitialWinCountUp extends BitmapWinCountUp {

    private _isCountUpSoundPlaying: boolean = false;
    private _hasCountUpEndSoundPlayed: boolean = false;

    constructor() {
        super({
            font: {
                name: "NumbersWinCountUp",
                size: 46
            },
            tint: parseInt(("#ffffff").replace(/^#/, ''), 16)
        });
    }

    private getScale(multiplier: number): number {
        return 1 + (multiplier - 1) * 0.1;
    }

    public getCountUpAnimation(from: number, to: number, duration: number, multiplier: number, isPlayCountUpEndSoundInReSpin : boolean = false): Timeline {
        const oriNumber: number = to / multiplier; //MathHelper.floorToDecimals(to / multiplier, 2);
        const timeline: TimelineLite = new TimelineLite();
        timeline.add([
            () => {
                this._countUp.maxTextWidth = GameConfig.instance.REEL_AREA_WIDTH * 0.9 / this.getScale(multiplier);
                this._countUp.alpha = 1;
                this._countUp.visible = true;
                this._countUpContainer.scale.set(1, 1);
                if (duration > 0.01) {
                    SoundManager.playSound(RomanEmpireSoundConfig.instance.COUNT_UP, Infinity);
                    this._isCountUpSoundPlaying = true;
                }else if(isPlayCountUpEndSoundInReSpin){
                    this._isCountUpSoundPlaying = true;//#254 to play count up end for tiny and small win
                }
            },
            this._countUp.getCountUpAnimation(from, oriNumber, {duration: duration, ease: Power3.easeInOut})
        ]);

        timeline.add(() => {
            this.stopCountUpSound();
        });

        if (multiplier > 1) {
            for (let m: number = 1; m <= multiplier; m++) {
                const showNumber: number = oriNumber * m;
                const scale: number = this.getScale(m);
                timeline.add([
                    () => EventHandler.dispatchEvent(new GameEvent(RomanEmpireEvents.ON_MULTIPLIER_COUNT_UP, m)),
                    this._countUp.getCountUpAnimation(showNumber, showNumber, {duration: 0.01}),
                    TweenLite.to(this._countUpContainer.scale, 0.3,
                        {
                            x: scale,
                            y: scale,
                            ease: Elastic.easeOut.config(2, 1)
                        }),
                ]);
                timeline.add(TweenLite.to(this, 0.3, {}));
            }
        }
        return timeline;
    }

    private stopCountUpSound(): void {
        Logger.logDev("stopCountUpSound called");

        if (this._isCountUpSoundPlaying) {
            Logger.logDev("stopCountUpSound stopCountUpSound ");
            SoundManager.stopSound(RomanEmpireSoundConfig.instance.COUNT_UP);
            this._isCountUpSoundPlaying = false;
            if (!this._hasCountUpEndSoundPlayed && !RomanEmpireGameConfig.instance.WIN_BELOW_STAKE) {
                Logger.logDev("stopCountUpSound playCountUpEnds ");
                SoundManager.playSound(RomanEmpireSoundConfig.instance.COUNT_UP_ENDS);
                this._hasCountUpEndSoundPlayed = true;
            }
        }
    }

    public abort(endValue: number, isAborted: boolean, multiplier: number, isBigWin: boolean): Timeline | null {
        if (isBigWin) {
            return null;
        }

        return super.abort(endValue, isAborted, multiplier);
    }

    protected getAbortAnimation(endValue: number, multiplier: number): Timeline {
        const timeline: TimelineLite = new TimelineLite();

        timeline.add([
            () => {
                this._countUp.maxTextWidth = GameConfig.instance.REEL_AREA_WIDTH * 0.9 / this.getScale(multiplier);
                this._countUp.alpha = 1;
                this._countUp.visible = true;
                this._countUpContainer.scale.set(1, 1);
            },
            this._countUp.getCountUpAnimation(endValue, endValue, {duration: 0.01})
        ]);
        if (multiplier > 1) {
            const scale: number = this.getScale(multiplier);
            timeline.add(TweenLite.to(this._countUpContainer.scale, 0.2, {
                x: scale,
                y: scale,
                ease: Elastic.easeOut.config(2, 1)
            }), 0)
        }

        return timeline;
    }

    /**
     * Override parent class function to fix overlapping issue (win count up and bet line win)
     * @param endValue
     */
    public getEndingAnimation(endValue: number): Timeline {
        const timeline: TimelineLite = new TimelineLite({
            onComplete: () => {
                this._isCountUpSoundPlaying = false;
                this._hasCountUpEndSoundPlayed = false;
            }
        });
        timeline.add(() => this.stopCountUpSound());
        timeline.add(this._countUp.getCountUpAnimation(endValue, endValue, {duration: 0.01}));
        //timeline.add(TweenLite.to(this._countUp, 0.5, {alpha: 0}), `+=0.8`); // stay a while after count up.
        //position params removed, fix overlapping issue wincountup and bet line win text.
        timeline.add(TweenLite.to(this._countUp, 0.5, {alpha: 0})); // stay a while after count up.

        return timeline;
    }

}